/* eslint-disable no-unused-vars */
import { get, post, uploadImg } from "./axios.js";

// 根据SN和型号, 获取桌面信息
export const selectDeskyopInfoBySnModel = (data) => {
  return get("selectDeskyopInfoBySnModel", data);
};

// 获取所有模板信息
export const getMuBanList = (data) => {
  return get("getMuBanList", data);
};

// 获取app列表
export const getAppList = (data) => {
  return get("getAppList", data);
};

// 个性化桌面自主配置
export const setDesktop = (data) => {
  return post("setDesktop", data);
};

// 修改个性化桌面自主配置
export const updataDesktop = (data) => {
  return post("updataDesktop", data);
};

// 根据Sn获取用户的所有桌面
export const getDesktopBySn = (data) => {
  return get("getDesktopBySn", data);
};

// 上传图片
export const uploadImage = (data, call) => {
  return uploadImg(data, call);
};
